import { API_URL, API_LOGIN_URL, CKEY } from '../../config.js'


import Vue from 'vue'
import * as types from '../../store/types.js'
import { store } from '../../store/store'
import axios from 'axios'

const DUMP_CALLS = false

export const unauthenticated = () => {
  localStorage.removeItem('currentUser');
  localStorage.removeItem('pusherTransportTLS');
  localStorage.removeItem('access_token');
  localStorage.removeItem("userFavoriteAssets");
  localStorage.removeItem("userFavoriteAssetsMeta");

  document.location = '/#/login'
} 

const rejectedCall = (err) => {
  console.log("ACCESS DENIED")
  if(err.response.status == 401){
    unauthorized();
  }
  else{
    console.error(`***** DEEPDIGITAL DATA ERROR (code ${err.response.status}, ${err.response.statusText}) *****`);
    console.error("***** Headers *****", err.response.headers);
    console.error("***** Response *****",err.response.data);
  }
}

export const apiRequest = (method, url, params, opt = {}) =>{

  let p = new Promise((resolve, reject) => {
    
    let headers = {'X-Tenant': CKEY, 'X-Localization': 'nl'}
    let include = ''

    // Login is currently running on different endpoint 
    let baseUrl = (url == "/oauth/token") ? API_LOGIN_URL : API_URL
    if(opt.noAuth != true){
      headers = {...headers, Authorization: `Bearer ${store.getters[types.USER_ACCESS_TOKEN]}`}
    }

    let queryString = ''
    for(let [optionName, optionValue] of Object.entries(opt)){
      if(queryString.includes('?')){
        queryString += `&${optionName}=${optionValue}`
      }
      else{
        queryString += `?${optionName}=${optionValue}`
      }
    }

    axios({
      method,
      url: `${baseUrl}${url}${queryString}`,
      data: params,
      headers: {
        ...headers
      }
    }).then((res) => {
      if(DUMP_CALLS){
        console.log({
          method,
          url,
          params,
          data: res.data.data
        });
      }

      // // add empty pagination object if res.data is empty
      // if(res.data.data.length == 0){
      //   res.data.meta = {pagination:{count:0,current_page:0,per_page:0,total:0,total_pages:0}}
      // }

      resolve({status: res.status, data: res.data, headers: res.headers})
    }).catch((error) => {
      // server unreachable if error response is not available
      if(!error.response){              
          reject({code:503, data: {error:"server_unavailable", error_text: "Server niet beschikbaar. Controleer uw internet verbinding"}});
          return;
      }
      // 401 means token is not valid anymore, logout user and remove credentials. go to login 
      else if(error.response.status == 401 && url != "/oauth/token"){        
        unauthenticated();
      }
      // user not authorized for given request show notification
      else if(error.response.status == 403 && url != "/oauth/token"){
        
        if(error.response.data && error.response.data.error == "ACTION_NOT_AUTHENTICATED" ){
          Vue.prototype.$notify(method+" request '"+url+"' unauthenticated. Please contact administrator",{color:"error"});
        }
        else{
          Vue.prototype.$notify("Geen autorisatie voor aanvraag",{color:"error"});
        }
      }
      
      if(!opt.hideErrorMessage ){
        let errorText = error.response.data.errorMessage;

        if(typeof error.response.data.error_text === 'object'){
          errorText = '';
            for (let [k, v] of Object.entries(error.response.data.error_text)) {
              errorText+= v[0]+"<br>"
            }
        }
      }

      reject({code: error.response.status, data: error.response.data, headers: error.response.headers});
    })
  })
  return p
}

const calculatePercentage = (loaded, total) => (Math.floor(loaded * 1.0) / total)

export const downloadFile = (url, params) => {

  let p = new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: `${API_URL}${url}`,
      responseType:'arraybuffer',
      data: params,
      headers: {
        'X-Tenant': CKEY,
        'X-Localization': 'nl',
        Authorization: `Bearer ${store.getters[types.USER_ACCESS_TOKEN]}`
      }
    }).then((response) => {
       var headers = response.headers
       var blob = new Blob([response.data], {type: headers['content-type']})
       var link = document.createElement('a')
       link.href = window.URL.createObjectURL(blob)
       link.download = params.downloadName
       link.click()
       resolve();
      //resolve({status: res.status, data: res.data, headers: res.headers})
    }).catch((error) => {
      console.log(error)
      if(error.response.status == 401){
        
        //unauthenticated()
      }
    })
    //directOpen(url, params)
    //resolve();
  })
  return p
}

export const directOpen = (url, params) => {

    url = `${API_URL}${url}?ckey=${CKEY}&access_token=${store.getters[types.USER_ACCESS_TOKEN]}&${toQueryString(params)}`;
    console.log("URL", url)
    window.open(url, '_blank');
    resolve();
}

const toQueryString = (paramsObject) => {
  return Object
    .keys(paramsObject)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`)
    .join('&')
  ;
}
